import { FC } from 'react';
import styled from 'styled-components';

const Block = styled.label`
  input {
    position: relative;
    top: 0px;
  }
`;

interface IProps {
  className?: string;
  defaultChecked?: boolean;
  checked: boolean;
  onChange: (e: any) => void;
  text?: string;
  disabled?: boolean;
  value?: string;
}

const Radio: FC<IProps> = ({
  className,
  defaultChecked,
  checked,
  onChange,
  text = '',
  disabled = false,
  value = '',
}) => {
  return (
    <Block className="pointer my-0">
      <input
        type="radio"
        className={'mr-1 pointer ' + (className ? className : '')}
        defaultChecked={defaultChecked}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        value={value}
      />
      {text}
    </Block>
  );
};

export default Radio;
